const baseFitmentFields = ['Make', 'Model', 'Year'];
const extraFitmentFields = ['Engine', 'Submodel'];

const categorySelectionPageUrl = '/category-list/';
const brandSelectionPageUrl = '/brands/';

export default {
  platform: 'bigcommerce',
  sortFields: ['relevance', 'name', 'name:desc', 'price', 'price:desc'],
  SearchRequestDefaults: {
    pageSize: 36,
  },
  fitmentSearch: {
    baseFields: baseFitmentFields,
    extraFields: extraFitmentFields,
    categorySelectionPages: [
      { pathname: categorySelectionPageUrl, field: 'category' },
      { pathname: brandSelectionPageUrl, field: 'brand_name' },
    ],
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#cm_results',
      template: 'SearchPage',
    },
    {
      name: 'CategoryPage',
      type: 'SearchPage',
      location: { replace: 'main.body.body-category .container .page' },
      template: 'SearchPage',
    },
    {
      name: 'BrandPage',
      type: 'SearchPage',
      location: { replace: 'main.body.body-brand .container .page' },
      template: 'SearchPage',
    },
    {
      name: 'FacetPanel',
    },
    { name: 'SearchResult' },
    {
      name: 'SearchHeader',
    },
    {
      name: 'SearchBox',
      location: {
        replace: 'header #quickSearch',
        class: 'dropdown dropdown--quickSearch cm_search-box-root__container',
      },
      template: 'SearchBox',
    },
    {
      name: 'SearchBoxDialogButton',
      location: {
        firstChildOf: '.header .topMenu + .container .searchWrap',
        class: 'dropdown dropdown--quickSearch cm_search-box-root__container-mobile',
      },
      template: 'searchBox/dialogButtonAdaptable',
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      location: '#cm_categories',
      template: 'facetTiles/hierarchicalContainer',
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: '#cm_brands',
      template: 'facetTiles/hierarchicalContainer',
    },
    {
      name: 'HeaderVehicleWidget',
      type: 'VehicleWidget',
      location: {
        firstChildOf: 'main.body',
        class: 'cm_vehicle-widget__header-container',
      },
      template: 'fitmentSearch/collapsibleVehicleWidget',
      initCollapsed: true,
      columnBreakpoint: 800,
    },
    {
      name: 'Garage',
      location: {
        lastChildOf: 'header .navPages-container .navPages-list',
        wrapper: 'li',
        class: 'navPages-item cm_garage__desktop',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'GarageMobile',
      type: 'Garage',
      location: {
        insertAfter: '.header .navUser-item.navUser-item--cart',
        class:
          'navUser-item navUser-item--cart customCart col-xs-12 col-sm-5 col-md-3 col-lg-3 cm_garage__mobile',
      },
      template: 'fitmentSearch/garage',
    },
    {
      name: 'VerifyFitment',
      location: {
        lastChildOf: 'body.bod-product section.productView-details.product-options',
      },
      template: 'fitmentSearch/verifyFitment',
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
    {
      name: 'VehicleWidgetDialog',
      template: 'fitmentSearch/dialog',
    },
  ],
};
